import { Box, Flex, Heading, Text } from "rebass/styled-components";
import ArrowDown from "../components/svg/arrow-down";
import { RichText } from "prismic-reactjs";
import { scroller } from "react-scroll";

const scrollTo = () => {
  scroller.scrollTo("about", {
    duration: 800,
    delay: 0,
    smooth: "easeInOutQuart",
  });
};

const Slogan = ({ data, children, maxWidth = "588px", sx, ...props }) => {
  return (
    <Box
      sx={{
        width: "100%",
        bg: "dark",
        backgroundSize: "cover",
        backgroundPosition: "center",
        textAlign: "center",
        bg: "gold",
        pt: "150px",
        backgroundImage:
          data.primary.image &&
          data.primary.image.url &&
          `url(${data.primary.image.url})`,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: "90%",
          maxWidth: maxWidth,
          pb: "57px",
          mx: "auto",
        }}
      >
        <Heading
          variant="title"
          sx={{
            textTransform: "uppercase",
            color:
              data.primary.image && data.primary.image.url ? "gold" : "white",
          }}
        >
          {data && data.primary.small_title}
        </Heading>
        {data && data.primary.title && (
          <Box
            variant="slogan"
            sx={{
              maxWidth: "600px",
              mx: "auto",
              color:
                data.primary.image && data.primary.image.url
                  ? "white"
                  : "black",
            }}
          >
            {data.primary.title}
          </Box>
        )}
        {data && data.primary.text.length > 0 && (
          <Box variant="headingContent" sx={{ p: { m: 0 } }}>
            {RichText.render(data.primary.text)}
          </Box>
        )}

        <Box
          mt="80px"
          sx={{
            mr: 2,
            "&:hover": { mt: "90px", mb: "-10px" },
            transition: "all 0.2s",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.preventDefault();
            scrollTo();
          }}
        >
          <ArrowDown
            fill={
              data.primary.image && data.primary.image.url ? "#d6b985" : "white"
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Slogan;
